<div class="desc-and-image">
  <img
    [src]="'../../assets/images/' + image"
    [alt]="image"
    class="group-criteria-img"
  />
  <p class="desc">{{ description }}</p>
</div>
